// 地图地址
export function mapSrc({ width = 500, height = 300, lat = "", lng = "" }) {
  return `http://restapi.amap.com/v3/staticmap?&zoom=17&scale=2&size=${width}*${height}&markers=-1,https://img1.halobear.com/invitation/mark.png,0:${lng ||
    116.397428},${lat || 39.90923}&key=517823f8f1d25adffabba46df2a374eb`;
}

// 打开地图
export function openMap({ lat, lng }) {
  const url = `https://uri.amap.com/marker?position=${lng ||
    116.397428},${lat || 39.90923}&name=`;
  window.location.href = url;
}
